/* eslint-disable no-constant-condition */
<template>
  <div>
    <a-card :bordered="false" :bodyStyle="tstyle">
      <div class="table-page-search-wrapper" v-if="hasPerm('baPatient:page')">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="创建时间">
                <a-date-picker style="width: 100%" placeholder="请选择创建时间" v-model="queryParam.createDate" />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="患者姓名">
                <a-input v-model="queryParam.patientname" allow-clear placeholder="请输入患者姓名" />
              </a-form-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="手机">
                <a-input v-model="queryParam.mobile" allow-clear placeholder="请输入手机" />
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="性别">
                  <!-- <a-input v-model="queryParam.sex" allow-clear placeholder="请输入性别" /> -->
                  <a-select v-model="queryParam.sex" placeholder="请选择性别">
                    <a-select-option value="1">男</a-select-option>
                    <a-select-option value="2">女</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="患者编号">
                  <a-input v-model="queryParam.patientno" allow-clear placeholder="请输入患者编号" />
                </a-form-item>
              </a-col>
            </template>

            <a-col :md="8" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>

    <a-card :bordered="false">
      <s-table ref="table" :columns="columns" :data="loadData" :alert="options.alert"
               :rowKey="(record) => record.patientid" :rowSelection="options.rowSelection"
      >
        <template class="table-operator" slot="operator">
          <x-down v-if="hasPerm('baPatient:export')" ref="batchExport" @batchExport="batchExport" />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="$refs.addForm.add(record)">详情</a>
        </span>

        <span slot="sex" slot-scope="text, record">
          {{ record.sex == 1? '男' : '女'}}
        </span>
        <span slot="mobile" slot-scope="text, record">
          {{ record.mobile.replace(/(\d{3})\d*(\d{4})/,'$1****$2')}}
        </span>
      </s-table>

      <add-form ref="addForm" @ok="handleOk" />
      <edit-form ref="editForm" @ok="handleOk" />
    </a-card>
  </div>
</template>

<script>
  import {STable, XDown} from '@/components'
  import moment from 'moment'
  import {baPatientPage, baPatientDelete, baPatientExport} from '@/api/modular/interhospital/bapatient/baPatientManage'
  import addForm from './addForm.vue'
  import editForm from './editForm.vue'

  export default {
    components: {
      STable,
      addForm,
      editForm,
      XDown
    },

    data() {
      return {
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {title: '就诊人编号', align: 'center', dataIndex: 'patientid'},
          {title: '病人HIS编码', align: 'center', dataIndex: 'patientcode'},
          {title: '就诊人', align: 'center', dataIndex: 'patientname'},
          {title: '性别', align: 'center', dataIndex: 'sex', scopedSlots: {customRender: 'sex'}},
          {title: '年龄', align: 'center', dataIndex: 'age'},
          {title: '手机号', align: 'center', dataIndex: 'mobile', scopedSlots: {customRender: 'mobile'}},
          {title: '详细住址(全)', align: 'center', dataIndex: 'address'},
          {title: '创建时间', align: 'center', dataIndex: 'ctstamp'}
        ],
        tstyle: {'padding-bottom': '0px', 'margin-bottom': '10px'},
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          return baPatientPage(Object.assign(parameter, this.switchingDate())).then((res) => {
            return res.data
          })
        },
        selectedRowKeys: [],
        selectedRows: [],
        options: {
          alert: {
            show: true, clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
      }
    },

    created() {
      if (this.hasPerm('baPatient:edit') || this.hasPerm('baPatient:delete')) {
        this.columns.push({title: '操作', width: '150px', dataIndex: 'action', scopedSlots: {customRender: 'action'}})
      }
    },

    methods: {
      moment,
      /**
       * 查询参数组装
       */
      switchingDate() {
        // const queryParambirthday = this.queryParam.birthdayDate
        // if (queryParambirthday != null) {
        //     this.queryParam.birthday = moment(queryParambirthday).format('YYYY-MM-DD')
        //     if (queryParambirthday.length < 1) {
        //         delete this.queryParam.birthday
        //     }
        // }
        // const queryParamcreateDate = this.queryParam.createDateDate
        // if (queryParamcreateDate != null) {
        //     this.queryParam.createDate = moment(queryParamcreateDate).format('YYYY-MM-DD')
        //     if (queryParamcreateDate.length < 1) {
        //         delete this.queryParam.createDate
        //     }
        // }
        if (this.queryParam.createDate) {
          this.queryParam.createDate = moment(this.queryParam.createDate).format('YYYY-MM-DD')
        }

        const obj = JSON.parse(JSON.stringify(this.queryParam))
        return obj
      },

      /**
       * 单个删除
       */
      singleDelete(record) {
        const param = [{'patientid': record.patientid}]
        this.baPatientDelete(param)
      },

      /**
       * 批量删除
       */
      batchDelete() {
        const paramIds = this.selectedRowKeys.map((d) => {
          return {'patientid': d}
        })
        this.baPatientDelete(paramIds)
      },

      baPatientDelete(record) {
        baPatientDelete(record).then((res) => {
          if (res.success) {
            this.$message.success('删除成功')
            this.$refs.table.clearRefreshSelected()
          } else {
            this.$message.error('删除失败') // + res.message
          }
        })
      },

      toggleAdvanced() {
        this.advanced = !this.advanced
      },

      onChangebirthday(date, dateString) {
        this.birthdayDateString = dateString
      },

      onChangecreateDate(date, dateString) {
        this.queryParam.createDate = dateString
      },

      /**
       * 批量导出
       */
      batchExport() {
        const paramIds = this.selectedRowKeys.map((d) => {
          return {'patientid': d}
        })
        baPatientExport(paramIds).then((res) => {
          this.$refs.batchExport.downloadfile(res)
        })
      },

      handleOk() {
        this.$refs.table.refresh()
      },

      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      }
    }
  }
</script>

<style lang="less" scoped>
  .table-operator {
    margin-bottom: 18px;
  }

  button {
    margin-right: 8px;
  }

</style>
